import {Field, EmploymentHistoryPositionState, formatDate } from "../containers" 
import * as Actions from '../actions'

export const removeErrorField = (errorFields:Field[], field:Field): Field[] => {
	if (errorFields) {
		let newErrorFields = [...errorFields]
		let index = newErrorFields.indexOf(field)
		if (index > -1) {
			newErrorFields.splice(index, 1)
		}
		return newErrorFields
	}
	return errorFields
}

export const reducer = (store: EmploymentHistoryPositionState, action: Actions.BaseAction) => {
	const newStore = _.cloneDeep(store)
	if (action.type != 'saveFailure') {
		newStore.serverErrors = undefined;
	}
	switch (action.type) {

		case 'changeStartDate': {
			let a = action as Actions.DateFieldAction
			newStore.startDate = formatDate(a.date)
			if (newStore.errorFields) {
				newStore.errorFields = removeErrorField(newStore.errorFields, 'startDate')
				newStore.errorFields = removeErrorField(newStore.errorFields, 'endDate')
			}
			return newStore
		}
		case 'changeEndDate': {
			let a = action as Actions.DateFieldAction
			newStore.endDate = formatDate(a.date)
			if (newStore.errorFields) {
				newStore.errorFields = removeErrorField(newStore.errorFields, 'startDate')
				newStore.errorFields = removeErrorField(newStore.errorFields, 'endDate')
			}
			return newStore
		}
		case 'changeCompanyName': {
			let a = action as Actions.FieldAction
			newStore.companyName = a.text
			if (newStore.errorFields) {
				newStore.errorFields = removeErrorField(newStore.errorFields, 'companyName')
			}
			return newStore
		}
		case 'changeCompanyId': {
			let a = action as Actions.ChangeCompanyId
			newStore.companyId = a.id
			// if no company selected
			if (a.id > 0) {
				newStore.companyName = a.text
				if (newStore.errorFields) {
					newStore.errorFields = removeErrorField(newStore.errorFields, 'companyName')
				}
			}
			return newStore
		}
		case 'changePositionTitle': {
			let a = action as Actions.FieldAction
			newStore.positionTitle = a.text
			return newStore
		}
		case 'validateFailure': {
			let a = action as Actions.ValidateFailure
			newStore.isSaving = false
			newStore.errorFields = a.errorFields
			return newStore
		}
		case 'save':
		case 'update':
		{
			newStore.isSaving = true
			return newStore
		}
		case 'saveFailure': {
			let a = action as Actions.SaveFailure
			newStore.isSaving = false
			newStore.serverErrors = a.serverErrors
			return newStore
		}
		case 'saveUpdateSuccess': {
			newStore.isSaving = false
			newStore.errorFields = []
			return newStore
		}
		case 'saveAddSuccess': {
			let a = action as Actions.SaveAddSuccess
			newStore.isSaving = false
			newStore.errorFields = []
			newStore.id = a.id
			return newStore
		}
		default:
			return store;
	}
}


// WEBPACK FOOTER //
// ./src/contacts/employmentHistory/reducers/reducers.ts